var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverallRounded(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FFF6E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7482 55.3683H42.3137C42.301 55.1224 42.277 54.8872 42.277 54.652C42.2756 47.685 42.2742 40.7181 42.277 33.7511C42.277 32.4734 42.7543 32.0257 44.0957 32.0231C45.0135 32.0217 45.9298 32.0231 46.8476 32.0231C48.3189 32.0231 48.7496 32.4213 48.7496 33.7992C48.751 40.1207 48.7496 46.4421 48.7496 52.7635V55.3683H48.7482Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5938 55.3713H22.2074C22.2074 55.1161 22.2074 54.8809 22.2074 54.6443C22.2074 48.8802 22.2074 43.116 22.2074 37.3519C22.2074 35.9646 22.6141 35.5891 24.1023 35.5891C25.1839 35.5891 26.2655 35.5757 27.347 35.5971C28.1123 35.6118 28.6503 36.0943 28.6517 36.8093C28.6574 42.9516 28.6475 49.094 28.6418 55.235C28.6418 55.2551 28.6291 55.2764 28.5952 55.3713H28.5938Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6534 55.3749H32.2684C32.2557 55.1277 32.2317 54.8938 32.2317 54.6599C32.2289 51.1905 32.2274 47.721 32.2317 44.2516C32.2317 42.9619 32.699 42.5169 34.0362 42.5129C35.1164 42.5102 36.198 42.4982 37.2781 42.5182C38.155 42.5342 38.7113 43.0301 38.7141 43.8413C38.7268 47.5994 38.7184 51.3575 38.7141 55.1157C38.7141 55.1798 38.6859 55.2426 38.6548 55.3723L38.6534 55.3749Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7271 55.3661H52.3562C52.3421 55.1175 52.3181 54.9023 52.3181 54.6858C52.3153 51.5277 52.3139 48.3697 52.3181 45.2116C52.3195 43.938 52.7586 43.5224 54.0831 43.5197C55.0941 43.517 56.1036 43.5143 57.1146 43.5197C58.2668 43.5277 58.7596 43.9781 58.761 45.0473C58.7667 48.2949 58.7638 51.5411 58.761 54.7887C58.761 54.9638 58.7398 55.1375 58.7257 55.3661H58.7271Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5883 56.7122C46.9634 56.7122 53.3371 56.7122 59.7123 56.7122C59.9481 56.7122 60.2248 56.644 60.407 56.7389C60.6569 56.8685 60.9986 57.1225 61 57.3256C61 57.5368 60.6752 57.7934 60.4338 57.9457C60.2841 58.0406 60.0229 57.9831 59.8111 57.9831C46.9437 57.9831 34.0776 57.9831 21.2102 57.9831C21.1636 57.9831 21.1156 57.9831 21.069 57.9831C20.5522 57.9872 19.9916 57.9751 20.0001 57.3176C20.0086 56.6975 20.5494 56.7095 21.0407 56.7095C27.5571 56.7122 34.072 56.7108 40.5883 56.7108V56.7122Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1088 26.0035C26.1088 27.2998 25.0314 28.3489 23.6717 28.377C22.3204 28.4051 21.1484 27.3038 21.1484 26.0048C21.1484 24.6977 22.3063 23.6085 23.6702 23.6352C25.0356 23.662 26.1102 24.7044 26.1088 26.0048V26.0035Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7409 35.1995C55.3571 35.1901 54.2445 34.1156 54.2671 32.8085C54.2882 31.5309 55.3967 30.4978 56.7507 30.4951C58.1359 30.4911 59.2669 31.5549 59.2613 32.8526C59.2556 34.1597 58.1289 35.2088 56.7395 35.1995H56.7409Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4308 23.3497C48.4279 24.6741 47.2983 25.746 45.9301 25.7192C44.5901 25.6939 43.4747 24.618 43.4733 23.3497C43.4733 22.036 44.6043 20.9828 45.9993 21.0002C47.3901 21.0176 48.4322 22.0253 48.4308 23.3497Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5548 34.3771C32.5703 33.0861 33.6745 32.0356 35.0201 32.0303C36.3714 32.0249 37.5547 33.1502 37.5363 34.4252C37.5194 35.7189 36.3418 36.7854 34.9679 36.7533C33.5884 36.7213 32.5379 35.6868 32.5534 34.3771H32.5548Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8381 25.5615C43.1798 25.8649 43.4834 26.1349 43.8392 26.4503C41.9457 28.3654 40.072 30.2605 38.1687 32.1877C37.8383 31.9003 37.5319 31.6344 37.1534 31.3056C39.0526 29.3878 40.9376 27.4833 42.8381 25.5629V25.5615Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4102 29.8923C54.084 30.2224 53.8002 30.5098 53.4769 30.8385C51.7585 29.327 50.0655 27.8369 48.3358 26.316C48.6323 25.9966 48.9048 25.7025 49.2367 25.3457C50.9593 26.8599 52.6819 28.3741 54.4102 29.8923Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2429 28.7479C26.5507 28.3803 26.8077 28.073 27.0958 27.7295C28.8777 29.0406 30.6342 30.3342 32.4161 31.6466C32.1309 31.9941 31.8655 32.3202 31.576 32.6744C29.7983 31.3647 28.0432 30.0723 26.2443 28.7479H26.2429Z",
    fill: "#FFC150"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_596",
    x: 16,
    y: 21,
    width: 49,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_596"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_596",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverallRounded);
export default __webpack_public_path__ + "static/media/overall_rounded.32d58188becb2eb7bb98d1933af4e483.svg";
export { ForwardRef as ReactComponent };